
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _35WVmK7BI5kJqyqZCVQMStIHoShn3KRwbNnXEffDPmAnMMeta } from "/builds/special/akinfeev/app/pages/35.vue?macro=true";
import { default as demoVUE6MVkXdsmBsAPH25T8XHpCHqbYiCX_iCJEl4PxcY0Meta } from "/builds/special/akinfeev/app/pages/demo.vue?macro=true";
import { default as drawDi3oFfubj8meGm7AY8Yly_wHP6vK2rS7t6tgoY67ZZYMeta } from "/builds/special/akinfeev/packages/draw/app/pages/draw.vue?macro=true";
import { default as quizXi27ylF_0p2beebFaPD8zZ0pZnpZrAz0X3zoPst1uRYMeta } from "/builds/special/akinfeev/packages/quiz/app/pages/quiz.vue?macro=true";
import { default as teambU8FnDhVzYUAkzwQL4XDvwru2kEH_5ovOOPXgA9biG8Meta } from "/builds/special/akinfeev/packages/team/app/pages/team.vue?macro=true";
import { default as final_Upv9wq_feSHE9zfyOSBTbJXXanBoWBN39rovCz96u4Meta } from "/builds/special/akinfeev/packages/final/app/pages/final.vue?macro=true";
import { default as indexcWq2IFV2IOrm9uBAMXE8FsuKsLa4q__J1wHwvz78W1sMeta } from "/builds/special/akinfeev/app/pages/index.vue?macro=true";
import { default as rulesnZJ4s81ATDcz7UNkJLcqMqOrUdu9LeDA9GuZbcf7i_AMeta } from "/builds/special/akinfeev/packages/rules/app/pages/rules.vue?macro=true";
import { default as start3FnsJe2zUbt6KwBG3wz4jMHvjJZMq8PEhQc3P0hHleoMeta } from "/builds/special/akinfeev/packages/start/app/pages/start.vue?macro=true";
import { default as prizesenyymmRPNxCI_PXg5Yojr8PK1FyXXdTa565sFaXgsiAMeta } from "/builds/special/akinfeev/app/pages/prizes.vue?macro=true";
import { default as galleryB_ROJ0frdmVXQaDeh6IRlp7KLFGruY1gghUA5pXRg5kMeta } from "/builds/special/akinfeev/app/pages/gallery.vue?macro=true";
import { default as messagembrcw1lYMh7TGuZtHJPSVjCZnfcftCKS7DUA9_wQO60Meta } from "/builds/special/akinfeev/app/pages/message.vue?macro=true";
import { default as gallery_452X9GZ_sGmPlmeOjBpcdVOpkxCW461vb5CRFgvpvct9t0Meta } from "/builds/special/akinfeev/app/pages/gallery-2.vue?macro=true";
export default [
  {
    name: "35",
    path: "/35",
    component: () => import("/builds/special/akinfeev/app/pages/35.vue")
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("/builds/special/akinfeev/app/pages/demo.vue")
  },
  {
    name: "draw",
    path: "/draw",
    component: () => import("/builds/special/akinfeev/packages/draw/app/pages/draw.vue")
  },
  {
    name: "quiz",
    path: "/quiz",
    component: () => import("/builds/special/akinfeev/packages/quiz/app/pages/quiz.vue")
  },
  {
    name: "team",
    path: "/team",
    component: () => import("/builds/special/akinfeev/packages/team/app/pages/team.vue")
  },
  {
    name: "final",
    path: "/final",
    component: () => import("/builds/special/akinfeev/packages/final/app/pages/final.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/special/akinfeev/app/pages/index.vue")
  },
  {
    name: "rules",
    path: "/rules",
    component: () => import("/builds/special/akinfeev/packages/rules/app/pages/rules.vue")
  },
  {
    name: "start",
    path: "/start",
    component: () => import("/builds/special/akinfeev/packages/start/app/pages/start.vue")
  },
  {
    name: "prizes",
    path: "/prizes",
    component: () => import("/builds/special/akinfeev/app/pages/prizes.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/builds/special/akinfeev/app/pages/gallery.vue")
  },
  {
    name: "message",
    path: "/message",
    component: () => import("/builds/special/akinfeev/app/pages/message.vue")
  },
  {
    name: "gallery-2",
    path: "/gallery-2",
    component: () => import("/builds/special/akinfeev/app/pages/gallery-2.vue")
  }
]